/* eslint-disable */
import React, { useEffect } from 'react';
import ReactGA, { FieldsObject } from 'react-ga';
import { useLocation } from 'react-router-dom';

const withTracker = <P extends {}>(WrappedComponent: React.ComponentType<P>, options: FieldsObject = {}) => {
  const trackPage = (page: string) => {
    ReactGA.pageview(page);
  };

  return (props: P) => {
    const location = useLocation();
    useEffect(() => {
      trackPage(location.pathname);
    }, [location.pathname]);

    return <WrappedComponent {...props} />;
  };
};

export default withTracker;
